import Vue from 'vue'
import Vuetify from 'vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify)

const opts = {
	theme: {
		dark: false,
    themes: {
      light: {
        primary: '#00FF00',
        secondary: '#b0bec5',
        anchor: '#8c9eff'
			},
			dark: {
        primary: '#00FF00',
        secondary: '#b0bec5',
        anchor: '#8c9eff'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
}

export default new Vuetify(opts)